export const GET_ADMIN_MANAGE_CAMPAIGN_REQUEST = "GET_ADMIN_MANAGE_CAMPAIGN_REQUEST";
export const GET_ADMIN_MANAGE_CAMPAIGN_SUCCESS = "GET_ADMIN_MANAGE_CAMPAIGN_SUCCESS";
export const GET_ADMIN_MANAGE_CAMPAIGN_FAIL = "GET_ADMIN_MANAGE_CAMPAIGN_FAIL";

export const CREATE_ADMIN_MANAGE_CAMPAIGN_REQUEST = "CREATE_ADMIN_MANAGE_CAMPAIGN_REQUEST";
export const CREATE_ADMIN_MANAGE_CAMPAIGN_SUCCESS = "CREATE_ADMIN_MANAGE_CAMPAIGN_SUCCESS";
export const CREATE_ADMIN_MANAGE_CAMPAIGN_FAIL = "CREATE_ADMIN_MANAGE_CAMPAIGN_FAIL";

export const UPDATE_ADMIN_MANAGE_CAMPAIGN_REQUEST = "UPDATE_ADMIN_MANAGE_CAMPAIGN_REQUEST";
export const UPDATE_ADMIN_MANAGE_CAMPAIGN_SUCCESS = "UPDATE_ADMIN_MANAGE_CAMPAIGN_SUCCESS";
export const UPDATE_ADMIN_MANAGE_CAMPAIGN_FAIL = "UPDATE_ADMIN_MANAGE_CAMPAIGN_FAIL";

export const DELETE_ADMIN_MANAGE_CAMPAIGN_REQUEST = "DELETE_ADMIN_MANAGE_CAMPAIGN_REQUEST";
export const DELETE_ADMIN_MANAGE_CAMPAIGN_SUCCESS = "DELETE_ADMIN_MANAGE_CAMPAIGN_SUCCESS";
export const DELETE_ADMIN_MANAGE_CAMPAIGN_FAIL = "DELETE_ADMIN_MANAGE_CAMPAIGN_FAIL";